import { ANALYTICS_CONFIG, TOKEN_ANALYTICS_CONFIG } from './analytics.config';
import { APP_CONFIG, TOKEN_CONFIG } from './app.config';
import { TOKEN_UNIVERSAL_LINKS_CONFIG, UNIVERSAL_LINKS_CONFIG } from './universal-links.config';

export default [
  { provide: TOKEN_CONFIG, useValue: APP_CONFIG },
  { provide: TOKEN_ANALYTICS_CONFIG, useValue: ANALYTICS_CONFIG },
  { provide: TOKEN_UNIVERSAL_LINKS_CONFIG, useValue: UNIVERSAL_LINKS_CONFIG },
];
